import { render, staticRenderFns } from "./newCupon.vue?vue&type=template&id=2645f1d2&scoped=true"
import script from "./newCupon.vue?vue&type=script&lang=js"
export * from "./newCupon.vue?vue&type=script&lang=js"
import style0 from "./newCupon.vue?vue&type=style&index=0&id=2645f1d2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2645f1d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2645f1d2')) {
      api.createRecord('2645f1d2', component.options)
    } else {
      api.reload('2645f1d2', component.options)
    }
    module.hot.accept("./newCupon.vue?vue&type=template&id=2645f1d2&scoped=true", function () {
      api.rerender('2645f1d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/matrix/newCupon.vue"
export default component.exports